import { StickyLinkCell } from 'src/common/components/ConfigurableTable/Components/Cells/StickyLinkCell';
import { Routes } from 'src/Routes.constants';

export const RSimSimIccidLinkCell = ({ value }: any) => {
  return (
    <div data-testid="primaryText">
      <StickyLinkCell value={value} to={`${Routes.simInventory}/${value}`} />
    </div>
  );
};
